<script lang="ts">
  import MenuList from "./MenuList.svelte";
  import FeatherIcon from "svelte-feather-icon";
  import { useLocation } from "svelte-navigator";
  import { activeMenu,pageBodyClass } from "../../store";
  import { _ } from "../../i18n";
  import { onMount } from "svelte";
  const location = useLocation();
  let selectTitle;
  // For Current Path name
  let pathname;
  $: pathname = $location.pathname;
  export let menu: any;
  export let level: number;
  let setActiveMenu: any;
  activeMenu.subscribe((value) => {
    setActiveMenu = value;
  });
  function shouldSetActive({ item }) {
    let returnValue:boolean = false;
    if (item?.path === pathname || pathname.toLowerCase().split("/").includes(item.title.toLowerCase())) {
      return true;
    }
    if (item?.menu) {
      item?.menu.every((subItem: any) => {
        returnValue = shouldSetActive({ item: subItem });
        return false;
      });
    }
  }
  // match menu item url with current url
  const ActiveNavLinkUrl = (path:any) => {
    return pathname === path ? true : "";
  };

  // Getting current layoutClass
  const urlParams = new URLSearchParams(window.location.search);
  const currentLayoutName = urlParams.get("layout");

  onMount(() => {
    menu.forEach((item: any) => {
      let gotValue = shouldSetActive({ item });
      if (gotValue) {
        let temp = [...setActiveMenu];
        temp[level] = item.title;
        activeMenu.update((value) => (value = temp));
      }
    });
  });

  const handleClick = (item, e) => {
    if(item.title === "Ecommerce"){
      pageBodyClass.update((value)=> value = true)
    }else{
      pageBodyClass.update((value)=> value = false)
    }
    if (item.menu) {
          e.preventDefault();
        }
        let temp = setActiveMenu;
        temp[level] = temp[level] !== item.title && item.title;
        activeMenu.update((value) => (value = [...temp]));
        selectTitle = item.title;
        {
            selectTitle === "FooterDark"
                ? document.getElementById("footer").classList.add("footer-dark")
                : document.getElementById("footer").classList.remove("footer-dark");
        }
        {
            selectTitle === "FooterFixed"
                ? document.getElementById("footer").classList.add("footer-fix")
                : document.getElementById("footer").classList.remove("footer-fix");
        }
    };
  //For scrollY value
  let y: number;
</script>

<svelte:window bind:scrollY={y} />
{#each menu as mainMenu}
  <li 
    class:dropdown={level === 0}
    class:active={setActiveMenu[level] === mainMenu.title}
  >
    <a href={currentLayoutName ? mainMenu.path+`?layout=${currentLayoutName}`: mainMenu.path}
      class={level === 0 ? "nav-link menu-title" : ""}
      class:submenu-title={level !== 0 && level % 2 != 0}
      class:active={setActiveMenu[level] === mainMenu.title}
      on:click={(e) => handleClick(mainMenu, e)}
    >
      {#if level === 0}
        <FeatherIcon icon={mainMenu.icon} />
      {/if}
        {$_(mainMenu.title)}
      {#if mainMenu?.menu}
        {#if setActiveMenu[level] === mainMenu.title}
          <div class="according-menu">
            <i class="fa fa-angle-down" />
          </div>
        {:else}
          <div class="according-menu">
            <i class="fa fa-angle-right" />
          </div>
        {/if}
      {/if}
    </a>
    {#if mainMenu?.menu}
      <ul
        class={level !== 0 && level % 2 != 0
          ? "nav-sub-childmenu submenu-content"
          : "nav-submenu menu-content"}
        class:active={level !== 0 && level % 2 != 0}
        style="display:  {(mainMenu.menu ? mainMenu.menu.map((innerItem) => ActiveNavLinkUrl(innerItem.path)).includes(true) : ActiveNavLinkUrl(mainMenu.path)) || setActiveMenu[level] === mainMenu.title ? 'block': 'none'};"
      >
        <MenuList menu={mainMenu.menu} level={level + 1} />
      </ul>
    {/if}
  </li>
{/each}
